export const goToPage = ( url: string ): void => {
	const { location } = window
	const { pathname } = location

	if ( pathname !== url ) {
		location.assign( url )
	}
}
